import script from "./MaskIcon.vue?vue&type=script&setup=true&lang=js"
export * from "./MaskIcon.vue?vue&type=script&setup=true&lang=js"

import "./MaskIcon.vue?vue&type=style&index=0&id=376926c9&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-376926c9"]])

export default __exports__